// Primary brand
export const PRIMARY             = '#071D49';
export const PRIMARY_DARK        = '#CC0033';
export const PRIMARY_HOVER       = '#E8001C';

// Dark backgrounds
export const DARK_BG             = '#030F25';
export const DARKER_BG           = '#010A1A';
export const DARK_TEXT_BG        = '#0F2A5A';

// Text
export const TEXT_PRIMARY        = '#505358';
export const TEXT_SECONDARY      = '#2c3952';
export const TEXT_MUTED          = '#9a9a9a';
export const TEXT_SLATE          = '#64748b';
export const TEXT_LIGHT_SLATE    = '#94a3b8';

// Accent
export const ACCENT_TEAL         = '#22d0ba';
export const ACCENT_TEAL_ALT     = '#03d0b8';
export const ACCENT_GOLD         = '#fdbe2c';
export const BRONZE              = '#cd7f32';

// Status — success
export const SUCCESS             = '#16a34a';
export const SUCCESS_DARK        = '#15803d';
export const SUCCESS_BG          = '#dcfce7';
export const SUCCESS_SHADOW      = 'rgba(34, 197, 94, 0.25)';

// Status — info
export const INFO                = '#2563eb';
export const INFO_DARK           = '#1d4ed8';
export const INFO_BG             = '#dbeafe';
export const INFO_BG_LIGHT       = '#bfdbfe';
export const INFO_SHADOW         = 'rgba(59, 130, 246, 0.25)';

// Status — error/danger
export const ERROR               = '#d32f2f';
export const ERROR_DARK          = '#b71c1c';
export const ERROR_BG            = '#ffebee';
export const ERROR_BORDER        = '#ef5350';
export const ERROR_BORDER_LIGHT  = '#ef9a9a';
export const ERROR_SHADOW        = 'rgba(211, 47, 47, 0.1)';

// Neutral
export const WHITE               = '#ffffff';
export const BLACK               = '#000000';
export const LIGHT_GRAY_BG       = '#f4f4f4';
export const MEDIUM_GRAY         = '#9a9a9a';
export const BORDER_GRAY         = 'rgba(162, 162, 162, 0.221)';

// Overlays
export const OVERLAY_DARK        = 'rgba(0, 0, 0, 0.7)';
export const OVERLAY_MEDIUM      = 'rgba(0, 0, 0, 0.12)';

// Social
export const WHATSAPP            = '#25D366';

// Gradients (used as gradient stop values)
export const GRADIENT_PINK_START = '#FE6B8B';
export const GRADIENT_PINK_END   = '#FF8E53';
